import React, {useState} from 'react';
import {BiCart} from "react-icons/bi";
import Cart from "./Cart";
import {useCart} from "../utilities/context/cart/cart-context";

const CartButton = ({...props}) => {

    const {getTotal} = useCart();

    const [open, setOpen] = useState(false);

    return (
        <div>
            <div onClick={() => setOpen(true)}
                className="fixed top-32 right-0 bg-black text-white p-4 rounded-l-xl hover:bg-opacity-60 cursor-pointer flex flex-col items-center">
                <BiCart className="text-lg"/>
                {getTotal() > 0 &&
                    <div className="text-xs select-none">{getTotal()}€</div>
                }

            </div>

            <div className={`${open ? "" : "hidden"} fixed top-0 bottom-0 right-0 w-full md:w-1/4 bg-black text-white pt-28`}>
                <div className="flex flex-row justify-end">
                    <button onClick={() => setOpen(false)}>Chiudi</button>
                </div>
                <Cart />
            </div>
        </div>
    );
}

export default CartButton;